module.exports = __webpack_public_path__ + "img/texture_3.a727367c.png";